import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { geolocationKeys } from "./useGeolocationSettingsQuery";

export interface Geofence {
  id: string;
  company_id: string;
  label: string;
  address: string;
  place_id: string | null;
  latitude: number;
  longitude: number;
  radius_meters: number;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export type GeofenceFilter = 'active' | 'inactive' | 'all';

async function fetchGeofences(
  companyId: string | undefined, 
  filter: GeofenceFilter
): Promise<Geofence[]> {
  if (!companyId) {
    return [];
  }

  let query = supabase
    .from("company_geofences")
    .select("*")
    .eq("company_id", companyId);

  // Apply filter
  if (filter === 'active') {
    query = query.eq("is_active", true);
  } else if (filter === 'inactive') {
    query = query.eq("is_active", false);
  }

  query = query.order("sort_order");

  const { data, error } = await query;

  if (error) {
    console.error("Error fetching geofences:", error);
    return [];
  }

  return data || [];
}

export function useGeofencesQuery(companyId: string | undefined, filter: GeofenceFilter) {
  return useQuery({
    queryKey: geolocationKeys.geofences(companyId, filter),
    queryFn: () => fetchGeofences(companyId, filter),
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
